import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function isEspaceProPath(path: string) {
  return path === "/espace-pro" || path.startsWith("/espace-pro/")
}

/** Open Espace Pro in a new tab when leaving the public site. */
export function shouldOpenEspaceProInNewTab(currentPathname: string, targetHref: string) {
  return isEspaceProPath(targetHref) && !isEspaceProPath(currentPathname)
}
